import cn from 'classnames';
import dayjs from 'dayjs';
import { FC } from 'react';
import { IoWarningOutline } from 'react-icons/io5';
import { Text } from '../../../../../../../components/text/text';
import { Tooltip } from '../../../../../../../features/tooltip/tooltip';
import { useManagerStore } from '../../../../../../../store/use-manager-store';
import { ShiftCellType } from '../shifts-helpers';
import s from './shifts-grid-daily.module.css';
import { useShiftsGridDaily } from './use-shifts-grid-daily';

const format = 'HH:mm';

export const ShiftsGridDaily: FC<ShiftCellType> = (props) => {
  // const { employee, date, index, onClick } = props;
  const { employee, date, onClick } = props;
  const { hasAccess } = useManagerStore();

  const shifts = employee?.shifts || [];
  const shift = shifts.find((shift) => {
    const startTime = dayjs(shift.start_time);
    const currentDate = dayjs(date);

    return (
      startTime.isSame(currentDate, 'day') &&
      startTime.format(format) === currentDate.format(format)
    );
  });

  const { isRender, range, timeToWidth, leftOffset, status } = useShiftsGridDaily({
    date,
    shift,
  });

  if (!isRender || !status) return null;

  return (
    <Tooltip
      wrapperClassName={s.feature}
      triggerWrapperClassName={cn(s.trigger, s[status])}
      onClickTrigger={() => onClick?.(shift ? [shift] : [], employee, date)}
      behavior="hover"
      disabled={!hasAccess('staff', ['write'])}
      trigger={
        <>
          {shift && (
            <div className={s.time}>
              {shift.start_time && <Text>{dayjs(shift.start_time).format(format)}</Text>}
              &nbsp;-&nbsp;
              {shift.end_time && <Text>{dayjs(shift.end_time).format(format)}</Text>}
            </div>
          )}
          {shift?.checkin && (
            <div className={s.time}>
              {shift.checkin.start_time && (
                <Text className={s[status.split('-')?.[0]]}>
                  {dayjs(shift.checkin.start_time).format(format)}
                </Text>
              )}
              &nbsp;-&nbsp;
              {shift.checkin.end_time && (
                <Text className={s[status.split('-')?.[1]]}>
                  {dayjs(shift.checkin.end_time).format(format)}
                </Text>
              )}
            </div>
          )}
          {status === 'absent' && <IoWarningOutline color="#FF6262" />}
        </>
      }
      // style={{ width: timeToWidth, zIndex: index, left: leftOffset }}
      style={{ width: timeToWidth, zIndex: 1, left: leftOffset }}
    >
      {range}
    </Tooltip>
  );
};
